<!--
 * @Author: Tina Huang
 * @Date: 2022-09-25 21:25:02
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-12 15:43:28
 * @Description: 
-->
<template>
  <div class="lib-container">
    <div class="sider-tab" :data-tab="active_tab">
      <h3
        class="tab-item"
        v-for="tabItem in tabList"
        :key="tabItem.tab"
        :class="active_tab === tabItem.tab ? 'active' : ''"
        @click="handleChangeTab(tabItem.tab)"
      >
        <el-badge v-if="tabItem.tag" :value="tabItem.tag" class="item">
          {{ tabItem.title }}
        </el-badge>
        <template v-else>{{ tabItem.title }}</template>
      </h3>
    </div>
    <div
      v-show="active_tab === tabItem.tab"
      v-for="tabItem in tabList"
      :key="tabItem.tab"
    >
      <component :is="tabItem.node" />
    </div>
  </div>
</template>
<script>
import tool from "../lib/index.js";
import Videos from "./Template/Video.vue";
import Lives from "./Template/Lives.vue";
import Picks from "./Template/Picks.vue";
export default {
  components: { Videos, Lives, Picks },
  data() {
    return {
      active_tab: +this.$route.params.tab || 0,
      isLogin: tool.isLogin(this.$token),
      tabList: [
        {
          tab: 0,
          title: "模板",
          node: "picks",
        },
        {
          tab: 1,
          title: "教程",
          node: "videos",
        },
        {
          tab: 2,
          title: "系列",
          tag: "即将上架",
          node: "lives",
        },
      ],
    };
  },
  methods: {
    handleChangeTab(tab) {
      this.active_tab = tab;
      this.$router.replace({ name: "picks", params: { tab } });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../less/var.less";
.lib-container {
  padding: 5vw;
  padding-top: 120px;
  min-height: 70vh;
  h2 {
    font-size: 30px;
    text-align: center;
  }
}
.template-list {
  padding-top: 50px;
  display: flex;
  flex-wrap: wrap;
  //   flex-direction: column;
  // justify-content: space-between;
  margin-left: -40px;
  // justify-content: space-around;
  .item {
    display: flex;
    width: 400px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
    margin-bottom: 14px;
    position: relative;
    margin-left: 40px;
    cursor: pointer;
    h3 {
      font-size: 20px;
      margin: 14px 0;
      display: flex;
      align-items: center;
      position: relative;
      .el-tag {
        margin-left: 5px;
        // position: absolute;
      }
    }
    p {
      font-size: 16px;
      margin: 25px 0;
    }
    .copy-btn {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
    .fix {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 111;
    }
    &.col {
      .cover {
        width: 200px;
        height: 100%;
        display: inline-block;
      }
      .info {
        width: 200px;
        height: 100%;
        box-sizing: border-box;
        padding: 14px;
      }
    }
    &.row {
      flex-direction: column;
      .cover {
        width: 100%;
        height: 170px;
        display: block;
        margin: 0 auto;
        object-fit: fill;
      }
      .info {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 14px;
        p {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .copy-btn {
        bottom: 58px;
      }
    }
  }
}
.sider-tab {
  width: 640px;
  height: 52px;
  background: @normal-bg;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  border-radius: 52px;
  position: relative;
  .tab-item {
    margin: 0;
    line-height: 52px;
    width: 210px;
    text-align: center;
    z-index: 1;
    cursor: pointer;
    font-size: 22px;
    &.active {
      color: #ffffff;
    }
  }
  &::after {
    content: "";
    position: absolute;
    width: 210px;
    height: 44px;
    border-radius: 45px;
    background: @primary-color;
    z-index: 0;
    left: 5px;
    top: 4px;
    transition: left 0.3s;
  }
}
.sider-tab[data-tab="1"]::after {
  left: calc(33.3%);
}
.sider-tab[data-tab="2"]::after {
  left: calc(66.7%);
}
.card-tag {
  margin-right: 10px;
}
.selector {
}

.col-price {
  position: absolute;
  right: 0;
}

.input-with-select {
  width: 300px;
  display: inline-block;
}
</style>
